export default __webpack_public_path__ + "static/media/icon_privacy_home_safety_icon-3.03a2decb.svg";